// Should a dropdown / date picker opened from `trigger` open UPWARD? Yes when there is not enough room below it and there is
// more room above. "Room" is measured against the nearest scrolling parent (a window or panel that clips it) as well as the screen,
// so a picker at the bottom of a scrolling pop-up opens above instead of hanging out of the bottom.
const clipsContent = (el) => {
    const { overflowY } = window.getComputedStyle(el);
    return overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'hidden' || overflowY === 'overlay';
};

export const opensUpward = (trigger, neededHeight) => {
    if (!trigger || typeof window === 'undefined') return false;
    const rect = trigger.getBoundingClientRect();
    let top = 0;
    let bottom = window.innerHeight;
    for (let el = trigger.parentElement; el && el !== document.body; el = el.parentElement) {
        if (!clipsContent(el)) continue;
        const box = el.getBoundingClientRect();
        top = Math.max(top, box.top);
        bottom = Math.min(bottom, box.bottom);
        break; // the nearest clipping parent is the one that matters
    }
    const spaceBelow = bottom - rect.bottom - 8;
    const spaceAbove = rect.top - top - 8;
    return spaceBelow < neededHeight && spaceAbove > spaceBelow;
};
